module.exports = __webpack_public_path__ + "img/logo_go_color.3e637479.png";